<!--
  * @Author: changyunxia
  * @Date:2020年10月14日 09:17:03
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月14日 09:17:03
  * @Description:会议室预定
  * @FilePath:@/views/MeetingReservation.vue
-->
<template>
  <div>
    <meetingHeader :title="'会议预定'" :right-show="false" />
    <MeetingFrom :meeting-data="meetingData" />
  </div>
</template>
<script>
import meetingHeader from '@/components/meeting/meetingHeader'
import MeetingFrom from '@/components/MeetingReservation/meetingFrom'
export default {
  name: 'MeetingReservation',
  components: {
    meetingHeader,
    MeetingFrom
  },
  data() {
    return {
      meetingData: null
    }
  },
  computed: {},
  watch: {},
  created() {
    this.meetingData = this.$route.query
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
</style>
